import React, { useCallback } from 'react';
import { SettingsItem } from 'design-system';
import * as Icons from 'design-system/icons';
import { selectUserOrganisation } from 'features/premium/selectors/tier';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import checkFeatureFlag from 'utils/featureFlags';
const icon = <Icons.IconBuildings gradientKey="skyBlue"/>;
const strings = {
    manageSubscriptions: {
        title: 'Organisation subscription',
        titleLink: 'Link organisation subscription',
    },
};
export const ManageOrganisationSubscriptionsItem = () => {
    const employer = useAppSelector(selectUserOrganisation);
    const navigation = useMainStackNavigation();
    const onPressManage = useCallback(() => {
        navigation.navigateDeprecated('ManageOrganisationSubscription');
    }, []);
    const onPressLinkOrganisation = useCallback(() => {
        navigation.navigateDeprecated('ManageOrganisationLink');
    }, []);
    const isEmployerBenefitRedemptionEnabled = useAppSelector((state) => checkFeatureFlag(state.utils.featureFlags, 'employer_benefit_redemption'));
    if (!isEmployerBenefitRedemptionEnabled) {
        return null;
    }
    if (employer) {
        return (<SettingsItem title={strings.manageSubscriptions.title} description={employer.companyName} onPress={onPressManage} icon={icon}/>);
    }
    return (<SettingsItem title={strings.manageSubscriptions.titleLink} onPress={onPressLinkOrganisation} icon={icon}/>);
};
